import { Injectable } from '@angular/core';
import { AjaxData, AjaxService } from './ajax.service';
import { ApiRoutesV2 } from '../common/routes';
import { HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { clone } from 'lodash';

export interface EmailUsages {
  monthlyUsage: number;
  monthlyLimit: number;
}

@Injectable()
export class EmailUsagesService {
  private readonly emailUsage$$: BehaviorSubject<EmailUsages> = new BehaviorSubject<EmailUsages>({
    monthlyLimit: 0,
    monthlyUsage: 0,
  });

  constructor(private readonly ajaxService: AjaxService) {
    this.ajaxService.get(ApiRoutesV2.reviewEmailUsage).subscribe((response: HttpResponse<AjaxData>) => {
      this.emailUsage$$.next({
        monthlyUsage: response.body.data.usage,
        monthlyLimit: response.body.data.limit,
      });
    });
  }

  public get emailUsages$(): Observable<EmailUsages> {
    return this.emailUsage$$.asObservable();
  }

  public increaseUsageBy(nbEmailSent: number): void {
    const newUsage: EmailUsages = clone(this.emailUsage$$.getValue());
    newUsage.monthlyUsage += nbEmailSent;
    this.emailUsage$$.next(newUsage);
  }
}
